<template>
    <b-container class="p-0">
        <div class="rw-determine-right-wrong">
            <div class="question-example mt-4">
                <p class="text-start section-title mb-0"><strong>Example</strong></p>
                <div class="example__block border p-2 rounded">
                    <img class="mw-100" :src="exampleImage" alt="" v-if="!qdata.example">
                    <div v-if="qdata.example">
                        <b-row >
                            <b-col cols="12" class="question-item mb-3" v-for="(item, index) in qdata.example.items" :key="index">
                                <b-card no-body class="p-0">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="image-block">
                                            <img class="mw-100 h-100" style="max-height: 200px" :src="imageSrc(item.image.src)" alt="">
                                        </div>
                                        <div class="text-block">
                                            <p class="m-0">{{ item.label.data.value }}</p>
                                        </div>
                                        <div class="radio-checkbox-block">
                                            <radio-true-false :value="item.checked" ></radio-true-false>
                                        </div>
                                    </div>
                                </b-card>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
            <div class="question-content mt-4">
                <p class="text-start section-title mb-0"><strong>Questions</strong></p>
                <b-row >
                    <b-col cols="12" class="question-item mb-3" v-for="(item, index) in qdata.imageTickHorizontal.items" :key="index">
                        <b-card no-body class="p-0">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="image-block">
                                    <img class="mw-100 h-100" :src="imageSrc(item.image.src)" alt="">
                                </div>
                                <div class="text-block">
                                    <p class="m-0">{{ item.label.data.value }}</p>
                                </div>
                                <div class="radio-checkbox-block">
                                    <radio-true-false v-model="item.choose" ></radio-true-false>
                                </div>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </div>
    </b-container>
</template>

<script>

import RadioTrueFalse from './components/RadioTrueFalse.vue'

import {
    BRow,
    BCol,
    BContainer
} from 'bootstrap-vue'

export default {
    name: 'rw_determine_right_wrong',
    components: {
        BRow,
        BCol,
        BContainer,
        RadioTrueFalse
    },
    props: {
        qdata: Object
    },
    data() {
        return {
            checkDarkIcon: require('@/assets/icons/check-dark.png'),
            imageDefault: require('@/assets/img-default.jpg'),
            exampleImage: require('@/assets/kidbox-example/rw_determine_right_wrong.jpg'),
            answer: null
        }
    },
    created () {
        if (this.qdata.imageTickHorizontal.items) {
            for (let index = 0; index < this.qdata.imageTickHorizontal.items.length; index++) {
                // .choose == ''
                this.$set(this.qdata.imageTickHorizontal.items[index], 'choose', '')
            }
        }
    },
    methods: {
        imageSrc (src) {
            if (src && src !== '') { return src }
            return this.imageDefault
        }
    },
    mounted() {
    },
    watch: {
        'qdata': {
            handler(value) {
                let result = []
                for (let index = 0; index < value.imageTickHorizontal.items.length; index++) {
                    const element = value.imageTickHorizontal.items[index];
                    result[index] = element.choose == '' ? null : element.choose
                }
                this.$emit('input', {
                    answers: result
                })
            },
            deep: true
        },
    }
}
</script>

<style scoped>
.checkbox {
    border: 2px solid;
    padding: 2px;
    margin: 10px;
    border-radius: 5px;
    cursor: pointer;
    width: 45px;
    height: 45px;
}

.image-block {
    max-width: 250px;
}

.question-item {
    max-height: 250px;
}

.text-block p {
    font-family: 'FS Ariston Comic Base';
    font-size: 2rem;
    color: #1177f3;
}

</style>